import { useQueryClient } from "react-query";
import { useContext } from "react";
import { GET_GRADUATES_APPLICATION_DATA } from "../constants";
import { IGraduatesApplication } from "../types";
import { ApplicationContext } from "../../../../context/ApplicationContext";
import useGetGradsApplicationData from "./useGetGradsApplicationData";

export default function useSetGradsApplicationData() {
  const {
    onlineApplicationId,
    recurlyAccountId,
    setRecurlyAccountId,
    setOnlineApplicationId,
    setSecurityKey,
  } = useContext(ApplicationContext);
  const queryClient = useQueryClient();
  const graduatesApplication = useGetGradsApplicationData();

  return function setGradsApplicationData(
    data: Partial<IGraduatesApplication>
  ) {
    if (data?.id && onlineApplicationId !== data.id) {
      setOnlineApplicationId(data.id);
      setSecurityKey(data.securityKey);
    }

    if (data?.accountId && recurlyAccountId !== data.accountId) {
      setRecurlyAccountId(data.accountId);
    }

    queryClient.setQueryData(GET_GRADUATES_APPLICATION_DATA, {
      ...graduatesApplication,
      ...data,
    });
  };
}
